var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      directives: [
        {
          name: "analytics",
          rawName: "v-analytics",
          value: _vm.feedEventlabel,
          expression: "feedEventlabel",
        },
      ],
      attrs: {
        href: _vm.feedItem.url,
        "data-gtm-related-number": _vm.relatedNumber,
        "data-gtm-logic-id": _vm.feedItem.logic_id,
        "data-gtm-feed-id": _vm.feedId,
        "data-gtm-order-position": _vm.orderPosition,
        "data-gtm-creation-id": _vm.creationId,
      },
      on: { click: _vm.onClick },
    },
    [
      _c(
        "div",
        {
          staticClass: "global-feed-list-img",
          class: { "global-feed-is-loading": !_vm.imageLoaded },
        },
        [
          _c(
            "figure",
            [
              _c("image-viewer", {
                attrs: {
                  src: _vm.feedItem.thumbnail,
                  "alt-src": _vm.noimage,
                  async: true,
                },
                on: { load: _vm.onLoad },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "global-feed-list-txt" }, [
        _c("p", { staticClass: "global-feed-list-title" }, [
          _vm._v(_vm._s(_vm.feedItem.title)),
        ]),
        _vm._v(" "),
        typeof _vm.feedItem === "object" &&
        typeof _vm.feedItem.recommend_avg === "number" &&
        _vm.feedItem.recommend_avg >= 0 &&
        _vm.feedItem.recommend_avg <= 7
          ? _c("div", { staticClass: "c-global-feed-list-rating-box" }, [
              _c("span", { class: _vm.starClass(_vm.feedItem.recommend_avg) }, [
                _c("span", { staticClass: "c-global-feed-list-rating-star" }),
                _vm._v(" "),
                _vm.feedItem.logic_id === "Logic-BFProduct"
                  ? _c(
                      "span",
                      { staticClass: "c-global-feed-list-rating-point" },
                      [_vm._v(_vm._s(_vm.feedItem.recommend_avg.toFixed(1)))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.feedItem.logic_id !== "Logic-BFProduct"
                  ? _c(
                      "span",
                      { staticClass: "c-global-feed-list-rating-point" },
                      [_vm._v(_vm._s(_vm.feedItem.recommend_avg))]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              typeof _vm.feedItem === "object" &&
              typeof _vm.feedItem.review_count === "number" &&
              _vm.feedItem.review_count >= 0
                ? _c(
                    "span",
                    { staticClass: "c-global-feed-list-rating-number" },
                    [_vm._v(_vm._s(_vm.feedItem.review_count) + "件")]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.feedItem.text
          ? _c("p", { staticClass: "global-feed-list-sub" }, [
              _vm._v(_vm._s(_vm.feedItem.text)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.feedItem.hashtag
          ? _c("p", { staticClass: "global-feed-hash-tag" }, [
              _vm._v(_vm._s(_vm.feedItem.hashtag)),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }